import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import "./App.css";

import "../src/utils/Lang/i18n.js";
import AnnouncementsMain from "./components/AnnouncementsMain/index.js";
import CoverMapMain from "./components/CoverMapMain/index.js";
import DeatelHome from "./components/DeatelMain/index.js";
import Home from "./components/Home/Home";
import InvestForum from "./components/InvestForum/index.js";
import JobMain from "./components/JobMain/index.js";
import NewMain from "./components/NewsMain/index.js";
import StructureMain from "./components/StructureMain/index.js";
import TendersShow from "./SubComponents/SubAnnouncementsComp/tendersComp/TendersShow.js";
import JobList from "./SubComponents/SubJobComponents/jobcomp/index.js";
import Jobshow from "./SubComponents/SubJobComponents/JobShow/index.js";
import NewsShow from "./SubComponents/SubNewsComp/NewsShow/index.js";

import CompetitionsShow from "./components/AnnouncementsMain/CompetitionsShow.js";
import ToursShowHome from "./components/Tours/showMain.js";
import ProjectsShowMore from "./SubComponents/SubcoverMap/CompanentMaps/ProjectsShowMore/index.js";
import SplashScreen from "./components/SplashScreen/index.js";
import ForumLondon from "./components/ForumLondon/index.js";
import { useEffect, useState } from "react";

function App() {
  const [loading, setLoading] = useState(() => {
    if (window.location.pathname === "/forum-london") return false;
    const hasSeenSplash = sessionStorage.getItem("splashShown");
    return !hasSeenSplash;
  });

  useEffect(() => {
    if (loading) {
      const timer = setTimeout(() => {
        setLoading(false);
        sessionStorage.setItem("splashShown", "true");
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [loading]);

  if (loading) {
    return <SplashScreen />;
  }

  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/deatel" element={<DeatelHome />} />
        <Route path="/structure" element={<StructureMain />} />
        <Route path="/maps" element={<CoverMapMain />} />
        <Route path="/tours/show/:id" element={<ToursShowHome />} />
        <Route path="/news" element={<NewMain />} />
        <Route path="/job" element={<JobMain />} />
        <Route path="/job/list/:id" element={<JobList />} />
        <Route path="/job/show/:id" element={<Jobshow />} />
        <Route path="/news/show/:id" element={<NewsShow />} />
        <Route path="/competitions" element={<AnnouncementsMain />} />
        <Route path="/competitions/show/:id" element={<CompetitionsShow />} />
        <Route path="/projectsShowMore/:id" element={<ProjectsShowMore />} />
        <Route path="/tenders/show/:id" element={<TendersShow />} />
        <Route path="/insights-forum" element={<InvestForum />} />
        <Route path="/forum-london" element={<ForumLondon />} />
      </Routes>
    </Router>
  );
}

export default App;
